import { render, staticRenderFns } from "./AbsentAlert.vue?vue&type=template&id=46f104f7"
import script from "./AbsentAlert.vue?vue&type=script&setup=true&lang=ts"
export * from "./AbsentAlert.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports